import React from "react";

import {
  articleSeasonImportApi,
  branchOfficeImportApi,
  clientImportApi,
  paymentMethodImportApi,
  pointsMovementImportApi,
  promotionImportApi,
  purchaseOrderImportApi,
  repositionOrderImportApi,
  skuImportApi,
} from "../../api/importClients";
import JsonlImportPage from "../../components/importexperience/JsonlImportPage";

export const ClientImport = () => (
  <JsonlImportPage
    titleKey="Common-ClientImport"
    descriptionKey="Common-ClientImportDescription"
    api={clientImportApi}
  />
);

export const SkuImport = () => (
  <JsonlImportPage
    titleKey="Common-SkuImport"
    descriptionKey="Common-SkuImportDescription"
    api={skuImportApi}
  />
);

export const ArticleSeasonImport = () => (
  <JsonlImportPage
    titleKey="Common-ArticleSeasonImport"
    descriptionKey="Common-ArticleSeasonImportDescription"
    api={articleSeasonImportApi}
  />
);

export const PaymentMethodImport = () => (
  <JsonlImportPage
    titleKey="Common-PaymentMethodImport"
    descriptionKey="Common-PaymentMethodImportDescription"
    api={paymentMethodImportApi}
  />
);

export const PromotionImport = () => (
  <JsonlImportPage
    titleKey="Common-PromotionImport"
    descriptionKey="Common-PromotionImportDescription"
    api={promotionImportApi}
  />
);

export const PointsMovementImport = () => (
  <JsonlImportPage
    titleKey="Common-PointsMovementImport"
    descriptionKey="Common-PointsMovementImportDescription"
    api={pointsMovementImportApi}
  />
);

export const BranchOfficeImport = () => (
  <JsonlImportPage
    titleKey="Common-BranchOfficeImport"
    descriptionKey="Common-BranchOfficeImportDescription"
    api={branchOfficeImportApi}
  />
);

export const PurchaseOrderImport = () => (
  <JsonlImportPage
    titleKey="Common-PurchaseOrderImport"
    descriptionKey="Common-PurchaseOrderImportDescription"
    api={purchaseOrderImportApi}
    requiresBusinessUnit
  />
);

export const RepositionOrderImport = () => (
  <JsonlImportPage
    titleKey="Common-RepositionOrderImport"
    descriptionKey="Common-RepositionOrderImportDescription"
    api={repositionOrderImportApi}
    requiresBusinessUnit
  />
);
